var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mt-3"},[_c('h3',[_vm._v("游戏列表")]),_c('p',[_c('GamesLinkList',{attrs:{"game_infos":_vm.game_infos}})],1)])}]

export { render, staticRenderFns }